export const hubspot = () => {
	contact()
	newsletter()
}

const contact = () => {

	let form = document.querySelector('#hubspot-contact-form')

	if (!form) return

	if (window.hbspt) {
		hbspt.forms.create({
			region: "eu1",
			portalId: "146218699",
			formId: "badf7208-782e-47d4-ac90-284b82d10e41",
			target: "#hubspot-contact-form"
		})
	}

}

const newsletter = () => {

	let form = document.querySelector('#hubspot-newsletter-form')

	if (!form) return

	if (window.hbspt) {
		hbspt.forms.create({
			region: "eu1",
			portalId: "146218699",
			formId: "4fe895db-32e7-4c28-92f6-4804b6cfa59d",
			target: "#hubspot-newsletter-form"
		})
	}

}

export default () => { }
